import React, { useEffect, useState } from "react";
import DashBoardApi from "../../services/Apis/DashBoard.Api";
import { useQuery } from "react-query";
import { Card, Grid, Typography } from "@mui/material";
import dynamicStyle from "./styles";

import { DailyComplains, StoreComplains } from "./Components";

const DashBoard = () => {
  const classes = dynamicStyle();

  // Total complains ..
  const { data: totalComplains } = useQuery(["GET_TOTALCOMPLAINs"], () =>
    DashBoardApi.getTotalComplains()
  );

  // Store complains ..
  const { data: storeComplains } = useQuery("STORES_COMPLAINS", () =>
    DashBoardApi.getStoresComplains()
  );

  // Per day complains ..

  const { data: perDayComplains } = useQuery("PER_DAY_COMPLAINS", () =>
    DashBoardApi.getWeeklyComplains()
  );

  // Store complains chart labels and values ..
  const storeComplainsLabels = storeComplains?.map((item) => item?.store);
  const storeComplainsValues = storeComplains?.map(
    (item) => item?.store_complaints
  );

  // per day complains chart labels and values  ..
  const perDayComplainsLabels = perDayComplains?.map((item) => item?.dayOfWeek);
  const perDayComplainsValues = perDayComplains?.map(
    (item) => item?.totalComplaints
  );

  const ComplainsCard = ({ title, value }) => {
    const classes = dynamicStyle();

    return (
      <Card xs={12} md={6}>
        <Grid className={classes.cardGrid}>
          <Typography variant="h6">{title}</Typography>
          <Typography className={classes.cardTypography} variant="h5">
            {value}
          </Typography>
        </Grid>
      </Card>
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <DailyComplains
          labels={perDayComplainsLabels}
          values={perDayComplainsValues}
          title="Daily Complains "
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <StoreComplains
          labels={storeComplainsLabels}
          values={storeComplainsValues}
          title="Store Complains"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        {totalComplains && totalComplains.length > 0 && (
          <ComplainsCard
            title="Total Complains"
            value={totalComplains[0]?.totalComplains}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default DashBoard;
